import React, { useState, useEffect } from 'react';
import { Grid, Icon, IconButton, makeStyles, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@material-ui/core';
import AddButton from '../../../../../../components/Buttons/AddButon';
import { grey } from '@material-ui/core/colors';

const header = [
    {id:1, label:'#Vial', padding:undefined},
    {id:2, label:'Producto', padding:undefined},
]

const SimpleMultitpleVias = (props) => {

    const {vials} = props
    const classes = useStyles()

    let viasContent = <div></div>

    if(vials && vials.length){
        viasContent = (
            <div>
                <div className={classes.vias_content}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                {header.map(item => {
                                    return(
                                        <TableCell padding={item.padding} key={`th-cell-${item.id}`}>
                                            {item.label}
                                        </TableCell>
                                    )
                                })}
                            </TableRow>
                        </TableHead>  
                        <TableBody>
                            {vials.map(item => {

                                const vialData = item


                                return (
                                    <TableRow key={`th-cell-${item.vialData?.number}`}>
                                        <TableCell>
                                            {vialData?.number}  
                                        </TableCell>
                                        <TableCell>{vialData?.product}</TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                </div>
            </div>
            
        )
    }


    return ( 
        <div>
            {viasContent}
        </div>
     );
}

const useStyles = makeStyles(theme => ({
    vias_content:{
        marginTop:4,
        padding:8,
        borderRadius:12,
        border:`1px solid ${grey[200]}`
    }
}))
 
export default SimpleMultitpleVias;